/**
 * Convert milliseconds to deciseconds.
 */
export function millisecondsToDeciseconds(ms: number): number {
  return Math.round(ms / 100);
}
